import {
  Box,
  Button,
  FormHelperText,
  Grid,
  InputLabel,
  CircularProgress,
  FormControl,
  Typography,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { useState } from "react";
import styles from "./LeadExpand.module.css";
import UserAssign from "../../../../../components/UserAssign/UserAssign";
import FlagAssign from "../../../../../components/FlagAssign/FlagAssign";
import { ErrorType } from "../../../../../components/FormTextInput/types";
import CountryCodePhoneInput from "../../../../../components/CountryCodePhoneInput/CountryCodePhoneInput";
import { isValidPhoneNumber } from "libphonenumber-js";
import closeIcon from "../../../../../components/LeadPopup/Assets/popup-close.svg";
import NewFormTextInput from "../../../../../components/FormTextInput/NewFormTextInput";
import { useAuthUser } from "react-auth-kit";
import { useSelector } from "react-redux";
import { resetLeadById, getLeadTaskList } from "../../service/nurtureSlice";
import { useDispatch } from "react-redux";
import { updateTaskAssignee } from "../../../Tasks/service/tasksSlice";
import SmallFormPopupSkeleton from "../../../../../components/Skeletons/SmallFormPopupSkeleton";
import SourceManager from "../../../../../components/SourceManager/SourceManager";
import { getCombinedAssignees } from "../../../../../components/CommonFunctions/CommonFunctions";
import { getEnquiryTags, createEnquiryTag } from "../../../../app/Settings/service/settingsSlice";
import { getSubDomainAccessStatus } from "../../../../../components/RolePermissionAccess/RolePermissionAccess";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import CheckIcon from "@mui/icons-material/Check";
import TextField from "@mui/material/TextField";

export default function LeadDetailsEdit(props: any) {
  const {
    toggleLeadEditModal,
    leadDetails,
    UpdateLead,
    isLeadEditOpen,
    users,
    assignyId,
    editDefaultPriority,
    setLeadEditOpen,
    onPhoneChangePopup,
    leadListByContact,
    leadPopupApiCall,
  } = props;
  const auth = useAuthUser();
  const authUser = auth();
  const dispatch = useDispatch();

  const {
    leadUpdateSuccess,
    leadUpdateLoading,
    leadByIdLoading,
    createSourceLoading,
    leadBoard,
  } = useSelector((state: any) => state.nurture);
  const sourceList = leadBoard?.sourceList;

  const { enquiryTags, createEnquiryTagLoading, createEnquiryTagSuccess } = useSelector(
    (state: any) => state.appSettings
  );

  const { userById } = useSelector((state: any) => state.userDetails);
  const hasAllAccess = getSubDomainAccessStatus(
    "SETTINGS",
    "CUSTOMIZE",
    "ALL_ACCESS",
    userById?.rolePermission
  );

  const instituteFromLocalStorage = JSON.parse(
    localStorage.getItem("ACTIVE_INSTITUTE")!
  );
  const instituteId = instituteFromLocalStorage?.id;

  const [isAddingTag, setIsAddingTag] = useState(false);
  const [newTagName, setNewTagName] = useState("");
  const pendingTagNameRef = React.useRef<string | null>(null);

  React.useEffect(() => {
    if (instituteId) {
      dispatch(getEnquiryTags(instituteId) as any);
    }
  }, [instituteId]);

  React.useEffect(() => {
    if (createEnquiryTagSuccess && instituteId) {
      dispatch(getEnquiryTags(instituteId) as any);
      setIsAddingTag(false);
      setNewTagName("");
    }
  }, [createEnquiryTagSuccess]);

  const allTags = React.useMemo(() => {
    const systemTags = enquiryTags?.systemTags ?? [];
    const customTags = enquiryTags?.customTags ?? [];
    return [...systemTags, ...customTags];
  }, [enquiryTags]);

  React.useEffect(() => {
    if (pendingTagNameRef.current && allTags?.length > 0) {
      const match = allTags.find(
        (t: any) =>
          t.tagName?.toLowerCase() === pendingTagNameRef.current?.toLowerCase()
      );
      if (match) {
        const tagName = match.tagName;
        pendingTagNameRef.current = null;
        setLead((prev: any) => ({
          ...prev,
          enquiryProfileTag: tagName,
        }));
      }
    }
  }, [allTags]);

  const getTagLabel = React.useCallback(
    (tagValue: string) => {
      const tag = allTags.find(
        (t: any) => t.tagName?.toUpperCase().replace(/\s+/g, "_") === tagValue
      );
      return tag?.tagName ?? "";
    },
    [allTags]
  );

  const getTagValue = React.useCallback(
    (tagLabel: string) => {
      const tag = allTags.find(
        (t: any) => t.tagName?.toLowerCase() === tagLabel?.toLowerCase()
      );
      return tag
        ? tag.tagName?.toUpperCase().replace(/\s+/g, "_")
        : "";
    },
    [allTags]
  );

  const [contactCountryCode, setContactCountryCode] = React.useState("91");

  const [lead, setLead] = React.useState({
    id: "",
    instituteId: "",
    instituteName: "",
    studentEmail: "",
    studentFirstName: "",
    studentLastName: "",
    studentContact: "",
    enquirySource: "",
    courseName: "",
    courseId: "",
    branchId: "",
    batchId: "",
    batchName: "",
    assignedToName: "",
    assignedToId: "",
    enquiryStatus: "",
    enquiryStatusId: "",
    enquiryPriority: "",
    status: "",
    contactCountryCode: contactCountryCode,
    updatedById: "",
    updatedByName: "",
    enquiryProfileTag: "",
  });

  const [source, setSource] = React.useState<any>("");
  const [sourceError, setSourceError] = React.useState<boolean>(false);
  const [originalAssigneeId, setOriginalAssigneeId] = React.useState<string | null>(null);
  const [showAssigneeConfirmation, setShowAssigneeConfirmation] = React.useState<boolean>(false);
  const [pendingAssignee, setPendingAssignee] = React.useState<any>(null);
  const [userAssignKey, setUserAssignKey] = React.useState<number>(0);
  const isUpdatingTasksRef = React.useRef<boolean>(false);

  React.useEffect(() => {
    if (isLeadEditOpen && leadDetails !== null && leadDetails !== undefined) {
      setLead({
        ...leadDetails,
        enquiryProfileTag: getTagLabel(leadDetails?.enquiryProfileTag),
        studentFirstName: leadDetails?.studentFirstName,
        studentLastName: leadDetails?.studentLastName,
      });

      const leadSource = sourceList?.find(
        (item: any) => item.key === leadDetails?.enquirySource
      );
      if (leadSource) {
        setSource(leadSource);
      }
      setContactCountryCode(leadDetails?.contactCountryCode);
      // Store the original assignee ID when modal opens or when leadDetails updates
      // This ensures we always have the latest assignee value
      setOriginalAssigneeId(leadDetails?.assignedToId || null);
      // Reset userAssignKey to ensure UserAssign component reflects the latest assignee
      setUserAssignKey((prev) => prev + 1);
    }
  }, [isLeadEditOpen, leadDetails, sourceList]);

  React.useEffect(() => {
    if (
      isLeadEditOpen &&
      leadDetails?.enquiryProfileTag &&
      allTags?.length > 0
    ) {
      const resolved = getTagLabel(leadDetails.enquiryProfileTag);
      if (resolved) {
        setLead((prev: any) => {
          if (!prev.enquiryProfileTag) {
            return { ...prev, enquiryProfileTag: resolved };
          }
          return prev;
        });
      }
    }
  }, [allTags, isLeadEditOpen, leadDetails, getTagLabel]);

  const [validStateEmail, setValidStateEmail] = React.useState<boolean>(true);
  const [validStatePhone, setValidStatePhone] = React.useState<boolean>(true);
  const [showErrMsz, setShowErrMsz] = React.useState<boolean>(true);
  const [errorType, setErrorType] = React.useState<ErrorType>("client");
  const [validStateFirstName, setValidStateFirstName] =
    React.useState<boolean>(true);
  const [minRequireError, setMinRequireError] = React.useState<boolean>(false);

  const handleChange = React.useCallback(
    (event: any) => {
      setShowErrMsz(true);
      if (errorType === "server") {
        setValidStateEmail(true);
      }
      setErrorType("client");

      setLead({
        ...lead,
        [event.target.id]: event.target.value,
      });
    },
    [lead, errorType]
  );

  const handleLeadPriority = React.useCallback(
    (leadId: any, leadPriority: any) => {
      setLead({ ...lead, enquiryPriority: leadPriority });
    },

    [lead]
  );

  const handleLeadAssignee = React.useCallback(
    (leadId: any, user: any) => {
      // Check if assignee is actually changing
      if (user?.id !== originalAssigneeId) {
        // Store the pending assignee and show confirmation popup immediately
        // Don't update the lead state yet - wait for user to confirm
        setPendingAssignee(user);
        setShowAssigneeConfirmation(true);
      } else {
        // Same assignee, no confirmation needed - apply immediately
        setLead({
          ...lead,
          assignedToId: user?.id,
          assignedToName: user?.firstName + " " + user?.lastName,
        });
      }
    },

    [lead, originalAssigneeId]
  );

  const handleConfirmAssigneeChange = React.useCallback(() => {
    // Apply the assignee change only when Save is clicked
    if (pendingAssignee) {
      setLead({
        ...lead,
        assignedToId: pendingAssignee?.id,
        assignedToName: pendingAssignee?.firstName + " " + pendingAssignee?.lastName,
      });
      setPendingAssignee(null);
    }
    setShowAssigneeConfirmation(false);
  }, [lead, pendingAssignee]);

  const handleCancelAssigneeChange = React.useCallback(() => {
    // Cancel - don't apply the change, restore the original assignee
    // Force UserAssign component to reset by updating its key
    setUserAssignKey((prev) => prev + 1);
    setPendingAssignee(null);
    setShowAssigneeConfirmation(false);
  }, []);

  const onSourceChange = React.useCallback(
    (value: any | null) => {
      if (value !== null) {
        setSource(value);
      } else {
        setSource("");
      }
    },
    [setSource]
  );

  const isValueInList = sourceList?.some(
    (item: any) => item.key === source?.key
  );

  const setValidateStatusEmail = React.useCallback((val: boolean) => {
    setValidStateEmail(val);
  }, []);

  const setValidateStatusPhone = React.useCallback((val: boolean) => {
    setValidStatePhone(val);
  }, []);

  const setValidateStatusFirstName = React.useCallback((val: boolean) => {
    setValidStateFirstName(val);
  }, []);

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    if (
      lead.studentContact?.startsWith("971") &&
      lead?.studentContact?.length !== 12
    ) {
      setValidStatePhone(false);
      return;
    }
    try {
      if (source === "") {
        setSourceError(true);
      } else {
        setSourceError(false);
      }
      console.log(lead?.enquiryProfileTag);
      if (source && isValueInList) {
        if (!lead.studentContact) {
          UpdateLead({
            ...lead,
            updatedById: authUser?.institute[0]?.id,
            updatedByName: authUser?.firstName + " " + authUser?.lastName,
            enquirySource: source?.key,
            enquiryProfileTag: getTagValue(lead?.enquiryProfileTag),
          });
        } else {
          if (!validStatePhone) {
            setValidStatePhone(false);
          } else {
            UpdateLead({
              ...lead,
              updatedById: authUser?.institute[0]?.id,
              updatedByName: authUser?.firstName + " " + authUser?.lastName,
              enquirySource: source?.key,
              enquiryProfileTag: getTagValue(lead?.enquiryProfileTag),
            });
          }
        }
      }
    } catch (error) { }
  };

  const handleResetLeadById = React.useCallback(() => {
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.delete("addLeadPayment");
    const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
    window.history.pushState({}, "", newUrl);
    dispatch(resetLeadById());
  }, []);

  const handlePhoneChange = React.useCallback(
    (event: any) => {
      event.preventDefault();
      if (
        lead.studentContact?.startsWith("971") &&
        lead?.studentContact?.length !== 12
      ) {
        setValidStatePhone(false);
        return;
      }
      if (source === "") {
        setSourceError(true);
      } else {
        setSourceError(false);
      }

      if (source && isValueInList) {
        if (!lead.studentContact) {
          onPhoneChangePopup({
            ...lead,
            updatedById: authUser?.institute[0]?.id,
            updatedByName: authUser?.firstName + " " + authUser?.lastName,
            enquirySource: source?.key,
          });
          setLeadEditOpen(false);
        } else {
          if (!validStatePhone) {
            setValidStatePhone(false);
          } else {
            onPhoneChangePopup({
              ...lead,
              updatedById: authUser?.institute[0]?.id,
              updatedByName: authUser?.firstName + " " + authUser?.lastName,
              enquirySource: source?.key,
            });
            setLeadEditOpen(false);
          }
        }
      }
    },
    [onPhoneChangePopup, source, lead]
  );

  const combinedAssignees = getCombinedAssignees(users, leadDetails?.branchId);

  React.useEffect(() => {
    if (
      leadUpdateSuccess !== true &&
      leadUpdateSuccess !== false &&
      isLeadEditOpen === true
    ) {
      const queryParams = new URLSearchParams(window.location.search);

      if (lead.studentEmail) {
        queryParams.set("leadEmail", lead.studentEmail);
      } else {
        queryParams.delete("leadEmail");
      }
      if (lead.studentContact) {
        queryParams.set("leadPhone", lead?.studentContact);
      } else {
        queryParams.delete("leadPhone");
      }
      queryParams.delete("addLeadPayment");
      const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
      window.history.pushState({}, "", newUrl);

      // Check if assignee was changed and update all tasks
      const assigneeChanged = originalAssigneeId !== lead.assignedToId;
      if (assigneeChanged && lead.assignedToId && lead.id && !isUpdatingTasksRef.current) {
        isUpdatingTasksRef.current = true;

        const updateTasksForLead = async () => {
          try {
            // Fetch tasks for this lead
            const tasksResult = await dispatch<any>(getLeadTaskList(lead.id));
            const tasks = tasksResult.payload;

            // Get the new assignee details - check combinedAssignees first, then fall back to users
            const newAssignee = combinedAssignees?.find((user: any) => user.id === lead.assignedToId) ||
              users?.find((user: any) => user.id === lead.assignedToId);

            // Update assignee for each task
            if (tasks && Array.isArray(tasks) && tasks.length > 0 && newAssignee) {
              const updatePromises = tasks.map((task: any) => {
                return dispatch<any>(updateTaskAssignee({
                  taskId: task.id,
                  assignedToId: lead.assignedToId,
                  assignedToName: `${newAssignee.firstName} ${newAssignee.lastName}`,
                }));
              });
              await Promise.all(updatePromises);
            }
          } catch (error) {
            console.error("Error updating task assignees:", error);
          } finally {
            isUpdatingTasksRef.current = false;
            setOriginalAssigneeId(null);
          }
        };

        updateTasksForLead();
      }

      setLeadEditOpen(false);
    }
  }, [leadUpdateSuccess, lead.assignedToId, lead.id, originalAssigneeId, users, combinedAssignees, dispatch]);

  React.useEffect(() => {
    if (source) {
      setSourceError(false);
    }
  }, [source]);
  console.log(lead);
  return (
    <div className={styles.leadEditWrapper}>
      <div className={styles.leadEditWrapperChild}>
        <div className={styles.popupClsWrap}>
          <button
            className={styles.clsBtn}
            onClick={() => {
              toggleLeadEditModal();
              handleResetLeadById();
            }}
          >
            <img src={closeIcon} alt="closeIcon" />
          </button>
        </div>
        {leadByIdLoading ? (
          <SmallFormPopupSkeleton />
        ) : (
          <>
            <div className={styles.popupTitle}>Edit Details </div>
            <form
              style={{
                display: "flex",
                flexDirection: "column",
                position: "relative",
              }}
              onSubmit={
                leadDetails?.studentContact !== lead?.studentContact &&
                  leadListByContact?.length > 1
                  ? handlePhoneChange
                  : handleSubmit
              }
            >
              <Grid
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
                container
                spacing={2}
              >
                <Grid item xs={12} lg={5.5}>
                  <NewFormTextInput
                    validate={true}
                    setValidStatus={setValidateStatusFirstName}
                    type={"text"}
                    id="studentFirstName"
                    label="First Name"
                    value={lead.studentFirstName}
                    onChange={(event: any) => {
                      setLead({
                        ...lead,
                        [event.target.id]: event.target.value.replace(/\d/, ""),
                      });
                    }}
                    error={!validStateFirstName}
                    showErrorMessage={showErrMsz}
                    errorType={errorType}
                    autoComplete="true"
                    require={true}
                    inputProps={{ maxLength: 20 }}
                  />
                </Grid>
                <Grid item xs={12} lg={5.5}>
                  <NewFormTextInput
                    validate={true}
                    type={"text"}
                    id="studentLastName"
                    label="Last Name"
                    value={lead.studentLastName}
                    onChange={(event: any) => {
                      setLead({
                        ...lead,
                        [event.target.id]: event.target.value.replace(/\d/, ""),
                      });
                    }}
                    showErrorMessage={showErrMsz}
                    errorType={errorType}
                    autoComplete="true"
                    inputProps={{ maxLength: 20 }}
                  />
                </Grid>
              </Grid>
              <Box sx={{ marginTop: "14PX", marginBottom: "14px" }}>
                <NewFormTextInput
                  disabled={
                    leadDetails && leadDetails.studentEmail === ""
                      ? false
                      : true
                  }
                  validate={true}
                  setValidStatus={setValidateStatusEmail}
                  label="Email Address"
                  type="email"
                  id={"studentEmail"}
                  error={!validStateEmail}
                  value={lead.studentEmail}
                  onChange={handleChange}
                  showErrorMessage={showErrMsz}
                  errorType={errorType}
                  autoComplete="true"
                  inputProps={{
                    maxLength: 50,
                  }}
                />
              </Box>
              <Box sx={{ mb: 2 }}>
                <InputLabel
                  sx={{
                    fontSize: "14px",
                    color: "#142C44",
                    fontWeight: "500",
                    marginBottom: "5px",
                    fontFamily: "Poppins",
                    display: "flex",
                  }}
                >
                  Phone Number
                </InputLabel>
                <CountryCodePhoneInput
                  value={lead.studentContact}
                  onChange={(event: any, country: any) => {
                    if (event !== "") {
                      setValidStatePhone(
                        isValidPhoneNumber(
                          event.replace(country.dialCode, ""),
                          country.countryCode.toUpperCase()
                        )
                      );
                    }
                    setLead({
                      ...lead,
                      studentContact: event,
                      contactCountryCode: country.dialCode,
                    });
                  }}
                  error={validStatePhone}
                />
                {minRequireError && (
                  <FormHelperText error={true}>
                    Please enter either phone number or email
                  </FormHelperText>
                )}
              </Box>
              <Box sx={{ marginBottom: "14px", textAlign: "center" }}>
                <InputLabel
                  sx={{
                    fontSize: "14px",
                    color: "#142C44",
                    fontWeight: "500",
                    marginBottom: "5px",
                    fontFamily: "Poppins",
                    display: "flex",
                  }}
                >
                  Source
                  <span style={{ margin: "0px 4px", color: "#D32F2F" }}>*</span>
                </InputLabel>
                <SourceManager
                  sourceList={sourceList}
                  onSourceChange={onSourceChange}
                  source={source}
                  addLead={false}
                />

                {sourceError === true && (
                  <FormHelperText error={true}>
                    Please select a source.
                  </FormHelperText>
                )}
              </Box>
              <Box sx={{ marginBottom: "14px", textAlign: "center" }}>
                <FormControl sx={{ margin: "6px 0", width: "100%" }}>
                  <Typography
                    sx={{
                      color: "#142C44",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "18px",
                      marginBottom: "6px",
                      textAlign: "start",
                    }}
                  >
                    Tag
                  </Typography>
                  {isAddingTag ? (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        padding: "4px 8px",
                      }}
                    >
                      <TextField
                        value={newTagName}
                        onChange={(e: any) => setNewTagName(e.target.value)}
                        size="small"
                        autoFocus
                        placeholder="Enter tag name"
                        onKeyDown={(e: any) => {
                          if (e.key === "Enter" && newTagName.trim() && hasAllAccess) {
                            pendingTagNameRef.current = newTagName.trim();
                            dispatch<any>(
                              createEnquiryTag({
                                tagName: newTagName.trim(),
                                instituteId: instituteId,
                                createdById: authUser?.institute?.[0]?.id,
                                createdByName:
                                  authUser?.firstName + " " + authUser?.lastName,
                              })
                            );
                          }
                          if (e.key === "Escape") {
                            setIsAddingTag(false);
                            setNewTagName("");
                          }
                        }}
                        inputProps={{
                          style: { padding: "6px 8px", fontSize: "13px" },
                        }}
                        sx={{ flex: 1, "& .MuiOutlinedInput-notchedOutline": { border: "none" } }}
                      />
                      {createEnquiryTagLoading ? (
                        <CircularProgress size={18} sx={{ color: "#11C89B" }} />
                      ) : (
                        <CheckIcon
                          onClick={() => {
                            if (newTagName.trim() && hasAllAccess) {
                              pendingTagNameRef.current = newTagName.trim();
                              dispatch<any>(
                                createEnquiryTag({
                                  tagName: newTagName.trim(),
                                  instituteId: instituteId,
                                  createdById: authUser?.institute?.[0]?.id,
                                  createdByName:
                                    authUser?.firstName +
                                    " " +
                                    authUser?.lastName,
                                })
                              );
                            }
                          }}
                          sx={{
                            fontSize: 18,
                            color: newTagName.trim() && hasAllAccess ? "#11C89B" : "#ccc",
                            cursor: newTagName.trim() && hasAllAccess ? "pointer" : "default",
                          }}
                        />
                      )}
                      <CloseIcon
                        onClick={() => {
                          setIsAddingTag(false);
                          setNewTagName("");
                        }}
                        sx={{
                          fontSize: 18,
                          color: "#667085",
                          cursor: "pointer",
                        }}
                      />
                    </Box>
                  ) : (
                    <Select
                      MenuProps={{
                        disablePortal: false,
                        style: {
                          zIndex: 999999,
                        },
                        PaperProps: {
                          style: {
                            boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.06)",
                            maxHeight: "150px",
                            marginTop: "4px",
                          },
                        },
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "left",
                        },
                        transformOrigin: {
                          vertical: "top",
                          horizontal: "left",
                        },
                      }}
                      placeholder="Select"
                      variant="outlined"
                      id="leadTag"
                      value={lead.enquiryProfileTag}
                      onChange={(e: any) => {
                        if (e?.target?.value === "__CUSTOM__") {
                          setIsAddingTag(true);
                          return;
                        }
                        setLead({
                          ...lead,
                          enquiryProfileTag: e?.target?.value,
                        });
                      }}
                      sx={{
                        "& .MuiOutlinedInput-input": {
                          padding: "10px 16px",
                          textAlign: "start",
                        },
                      }}
                    >
                      {hasAllAccess && (
                        <MenuItem
                          sx={{
                            fontSize: "13PX",
                            color: "#11C89B",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                          }}
                          value="__CUSTOM__"
                          key="custom-tag-option"
                        >
                          <SettingsOutlinedIcon
                            sx={{ fontSize: 16, color: "#11C89B" }}
                          />
                          Custom
                        </MenuItem>
                      )}
                      {allTags?.map((item: any, index: number) => (
                        <MenuItem
                          sx={{
                            fontSize: "13PX",
                            color: "#18181B",
                          }}
                          value={item?.tagName}
                          key={`${item.id}-${index}`}
                        >
                          {item?.tagName}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                </FormControl>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginBottom: "14px",
                }}
              >
                {leadDetails && (
                  <UserAssign
                    key={userAssignKey}
                    selectedAssignyId={leadDetails && lead?.assignedToId}
                    users={users && combinedAssignees}
                    handleLeadAssignee={handleLeadAssignee}
                    isForEnquiryModal={true}
                  />
                )}

                {leadDetails && (
                  <FlagAssign
                    selectedPriority={editDefaultPriority}
                    handleLeadPriority={handleLeadPriority}
                    isForEnquiryModal={true}
                  />
                )}
              </Box>

              <div className={styles.courseEditBtns}>
                <Button
                  fullWidth
                  onClick={() => {
                    toggleLeadEditModal();
                    handleResetLeadById();
                  }}
                  sx={{
                    textTransform: "capitalize",
                    color: "#9A9EA6",
                    borderColor: "#D0D5DD",
                    border: "1px solid",
                    borderRadius: "4PX",
                    ":hover": {
                      color: "#9A9EA6",
                      borderColor: "#D0D5DD",
                      backgroundColor: "#9a9ea612",
                    },
                  }}
                  variant="outlined"
                >
                  cancel
                </Button>
                <Button
                  fullWidth
                  color="primary"
                  variant="contained"
                  type="submit"
                  sx={{
                    border: "1px solid",
                    borderRadius: "4PX",
                    marginBottom: "0",
                    textTransform: "capitalize",
                  }}
                  disabled={leadUpdateLoading || createSourceLoading}
                >
                  {leadUpdateLoading ? (
                    <CircularProgress size={20} color={"inherit"} />
                  ) : (
                    "Save"
                  )}
                </Button>
              </div>
            </form>
          </>
        )}
      </div>
      <Dialog
        open={showAssigneeConfirmation}
        onClose={handleCancelAssigneeChange}
        aria-labelledby="assignee-confirmation-dialog-title"
        aria-describedby="assignee-confirmation-dialog-description"
        sx={{
          zIndex: "999999",
          "& .MuiDialog-paper": {
            zIndex: "999999",
            minWidth: "400px",
            maxWidth: "500px",
            borderRadius: "12px",
            boxShadow:
              "0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08)",
            // padding: "10px 24px 24px 24px",
            padding: "24px",
          },
        }}
        BackdropProps={{
          style: {
            zIndex: "999999",
          },
        }}
      >
        <DialogTitle
          id="assignee-confirmation-dialog-title"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            textAlign: "center",
            padding: "0 0 16px 0",
            "& .MuiDialogTitle-root": {
              padding: 0,
            },
          }}
        >
          <span>Confirm Assignee Change</span>
          <IconButton
            aria-label="close"
            onClick={handleCancelAssigneeChange}
            sx={{
              color: "#667085",
              padding: "4px",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.04)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ padding: "0 0 16px 0" }}>
          <DialogContentText id="assignee-confirmation-dialog-description">
            Are you sure you want to change the assignee? This action will reassign all tasks to the selected assignee.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ padding: "0", gap: "8px" }}>
          <Button
            onClick={handleCancelAssigneeChange}
            color="primary"
            variant="outlined"
            sx={{
              textTransform: "capitalize",
              borderRadius: "4px",
              minWidth: "100px",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmAssigneeChange}
            color="primary"
            variant="contained"
            sx={{
              textTransform: "capitalize",
              borderRadius: "4px",
              minWidth: "100px",
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
